import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Container, Group } from "@mantine/core";
import { fetchCommunications, selectCommunication } from "../../../data/actions/adminCommunicationActions";
import { IState } from "../../../data/reducers/state";
import CommunicationsFilter from "./CommunicationsFilter";
import CommunicationsList from "./CommunicationsList";
import CommunicationPreview from "./CommunicationPreview";

interface CommunicationsViewerProps {
  // Redux props
  communications: any[];
  persons: { [id: string]: any };
  selectedId: string | null;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  filters: any;
  loading: boolean;
  error: string | null;
}

const CommunicationsViewer: React.FunctionComponent<CommunicationsViewerProps> = ({
  communications,
  persons,
  selectedId,
  pagination,
  filters,
  loading,
  error,
}) => {
  const dispatch = useDispatch();

  // Load initial communications
  useEffect(() => {
    document.title = "Stadium Supervisor - Communications";
    dispatch(fetchCommunications({ page: 1, limit: 50 }) as any);
  }, [dispatch]);

  const handleCommunicationSelect = (communicationId: string) => {
    dispatch(selectCommunication(communicationId));
  };

  const handlePageChange = (page: number) => {
    dispatch(fetchCommunications({ 
      ...filters, 
      page, 
      limit: pagination.limit 
    }) as any);
  };

  const handleFilterChange = (newFilters: any) => {
    dispatch(fetchCommunications({ 
      ...newFilters, 
      page: 1, 
      limit: pagination.limit 
    }) as any);
  };

  const selectedCommunication = selectedId 
    ? communications.find(c => c._id === selectedId)
    : null;

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-grow-1 d-flex">
        <div className="d-flex flex-column border-end" style={{ width: '40%' }}>
          <div className="p-3 border-bottom">
            <h4 className="mb-3">Communications</h4>
            <CommunicationsFilter 
              filters={filters}
              onFiltersChange={handleFilterChange}
              loading={loading}
            />
          </div>
          
          <div className="flex-grow-1 overflow-hidden">
            <CommunicationsList
              communications={communications}
              persons={persons}
              selectedId={selectedId}
              onSelect={handleCommunicationSelect}
              pagination={pagination}
              onPageChange={handlePageChange}
              loading={loading}
              error={error}
            />
          </div>
        </div>

        <div className="d-flex flex-column" style={{ width: '60%' }}>
          <CommunicationPreview
            communication={selectedCommunication}
            persons={persons}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  communications: state.adminCommunications.communications,
  persons: state.adminCommunications.persons,
  selectedId: state.adminCommunications.selectedId,
  pagination: state.adminCommunications.pagination,
  filters: state.adminCommunications.filters,
  loading: state.adminCommunications.loading,
  error: state.adminCommunications.error,
});

export default connect(mapStateToProps)(CommunicationsViewer);
